export default __webpack_public_path__ + "static/media/Standard36.8961f2d9.png";